<template>
  <div v-if="!setItemTable" class="legalconfig-container">
    <div>LEGAL DOCUMENT CONFIGURATION</div>
    <b-table
      striped
      responsives
      :items="itemTable"
      :fields="fields"
      sticky-header="90%"
      @row-clicked="editLegal"
    >
      <template v-slot:cell(bidang_usaha)="data">
        <span>{{ data.value }}</span>
      </template>
      <template v-slot:cell(formulir_informasi_vendor)="data">
        <span v-if="data.value"
          ><i class="material-icons text-check">check</i></span
        >
        <span v-else><i class="material-icons text-close">close</i></span>
      </template>
      <template v-slot:cell(informasi_rekening)="data">
        <span v-if="data.value"
          ><i class="material-icons text-check">check</i></span
        >
        <span v-else><i class="material-icons text-close">close</i></span>
      </template>
      <template v-slot:cell(ktp_pengurus)="data">
        <span v-if="data.value"
          ><i class="material-icons text-check">check</i></span
        >
        <span v-else><i class="material-icons text-close">close</i></span>
      </template>
      <template v-slot:cell(kartu_keluarga)="data">
        <span v-if="data.value"
          ><i class="material-icons text-check">check</i></span
        >
        <span v-else><i class="material-icons text-close">close</i></span>
      </template>
      <template v-slot:cell(akta_pendirian_perseroan)="data">
        <span v-if="data.value"
          ><i class="material-icons text-check">check</i></span
        >
        <span v-else><i class="material-icons text-close">close</i></span>
      </template>
      <template v-slot:cell(akta_penyesuaian_pt)="data">
        <span v-if="data.value"
          ><i class="material-icons text-check">check</i></span
        >
        <span v-else><i class="material-icons text-close">close</i></span>
      </template>
      <template v-slot:cell(anggaran_dasar_terakhir_perseroan)="data">
        <span v-if="data.value"
          ><i class="material-icons text-check">check</i></span
        >
        <span v-else><i class="material-icons text-close">close</i></span>
      </template>
      <template v-slot:cell(akta_perubahan_pengurus_terakhir_perseroan)="data">
        <span v-if="data.value"
          ><i class="material-icons text-check">check</i></span
        >
        <span v-else><i class="material-icons text-close">close</i></span>
      </template>
      <template v-slot:cell(npwp)="data">
        <span v-if="data.value"
          ><i class="material-icons text-check">check</i></span
        >
        <span v-else><i class="material-icons text-close">close</i></span>
      </template>
      <template v-slot:cell(sppkp_pajak)="data">
        <span v-if="data.value"
          ><i class="material-icons text-check">check</i></span
        >
        <span v-else><i class="material-icons text-close">close</i></span>
      </template>
      <template v-slot:cell(skt_pajak)="data">
        <span v-if="data.value"
          ><i class="material-icons text-check">check</i></span
        >
        <span v-else><i class="material-icons text-close">close</i></span>
      </template>
      <template v-slot:cell(sk_domisili_situ_ig)="data">
        <span v-if="data.value"
          ><i class="material-icons text-check">check</i></span
        >
        <span v-else><i class="material-icons text-close">close</i></span>
      </template>
      <template v-slot:cell(siup)="data">
        <span v-if="data.value"
          ><i class="material-icons text-check">check</i></span
        >
        <span v-else><i class="material-icons text-close">close</i></span>
      </template>
      <template v-slot:cell(nib)="data">
        <span v-if="data.value"
          ><i class="material-icons text-check">check</i></span
        >
        <span v-else><i class="material-icons text-close">close</i></span>
      </template>
      <template v-slot:cell(tdp)="data">
        <span v-if="data.value"
          ><i class="material-icons text-check">check</i></span
        >
        <span v-else><i class="material-icons text-close">close</i></span>
      </template>
      <template v-slot:cell(sbu)="data">
        <span v-if="data.value"
          ><i class="material-icons text-check">check</i></span
        >
        <span v-else><i class="material-icons text-close">close</i></span>
      </template>
      <template v-slot:cell(iujk)="data">
        <span v-if="data.value"
          ><i class="material-icons text-check">check</i></span
        >
        <span v-else><i class="material-icons text-close">close</i></span>
      </template>
      <template v-slot:cell(iu_pelayaran)="data">
        <span v-if="data.value"
          ><i class="material-icons text-check">check</i></span
        >
        <span v-else><i class="material-icons text-close">close</i></span>
      </template>
      <template v-slot:cell(iujp)="data">
        <span v-if="data.value"
          ><i class="material-icons text-check">check</i></span
        >
        <span v-else><i class="material-icons text-close">close</i></span>
      </template>
      <template v-slot:cell(iu_niaga)="data">
        <span v-if="data.value"
          ><i class="material-icons text-check">check</i></span
        >
        <span v-else><i class="material-icons text-close">close</i></span>
      </template>
      <template v-slot:cell(financial_report)="data">
        <span v-if="data.value"
          ><i class="material-icons text-check">check</i></span
        >
        <span v-else><i class="material-icons text-close">close</i></span>
      </template>
    </b-table>
    <div>
      <b-button class="btn-legal mr-1" @click="addLegal">Add New Row</b-button>
    </div>
  </div>
</template>
<script>
import { api } from '../services/config'
import axios from 'axios'
export default {
  name: 'legalconfig',
  data() {
    return {
      fields: [
        { key: 'bidang_usaha', label: 'Bidang Usaha', thClass: 'bg-head' },
        {
          key: 'formulir_informasi_vendor',
          label: 'Formulir Informasi vendor',
          thClass: 'bg-head',
        },
        {
          key: 'informasi_rekening',
          label: 'Informasi rekening',
          thClass: 'bg-head',
        },
        { key: 'ktp_pengurus', label: 'KTP Pengurus', thClass: 'bg-head' },
        { key: 'kartu_keluarga', label: 'Kartu Keluarga', thClass: 'bg-head' },
        {
          key: 'akta_pendirian_perseroan',
          label: 'Akta Pendirian Perseroan',
          thClass: 'bg-head',
        },
        {
          key: 'akta_penyesuaian_pt',
          label: 'Akta Penyesuaian PT',
          thClass: 'bg-head',
        },
        {
          key: 'anggaran_dasar_terakhir_perseroan',
          label: 'Anggaran Dasar Terakhir Perseroan',
          thClass: 'bg-head',
        },
        {
          key: 'akta_perubahan_pengurus_terakhir_perseroan',
          label: 'Akata Perubahan Pengurus Terakhir Perseroan',
          thClass: 'bg-head',
        },
        { key: 'npwp', label: 'NPWP', thClass: 'bg-head' },
        { key: 'sppkp_pajak', label: 'SPPKP Pajak', thClass: 'bg-head' },
        { key: 'skt_pajak', label: 'SKT Pajak', thClass: 'bg-head' },
        {
          key: 'sk_domisili_situ_ig',
          label: 'SK Domisili SITU IG',
          thClass: 'bg-head',
        },
        { key: 'siup', label: 'SIUP', thClass: 'bg-head' },
        { key: 'nib', label: 'NIB', thClass: 'bg-head' },
        { key: 'tdp', label: 'TDP', thClass: 'bg-head' },
        { key: 'sbu', label: 'SBU', thClass: 'bg-head' },
        { key: 'iujk', label: 'IUJK', thClass: 'bg-head' },
        { key: 'iu_pelayaran', label: 'IU Pelayaran', thClass: 'bg-head' },
        { key: 'iujp', label: 'IUJP', thClass: 'bg-head' },
        { key: 'iu_niaga', label: 'IU Niaga', thClass: 'bg-head' },
        {
          key: 'financial_report',
          label: 'Financial Report',
          thClass: 'bg-head',
        },
      ],
      itemTable: null,
    }
  },
  created() {
    const self = this
    self.$store.dispatch('toggleSidebar', false)
    self.getLegalConfig()
  },
  computed: {
    setItemTable() {
      this.getLegalConfig()
    },
  },
  methods: {
    getLegalConfig() {
      axios({
        method: 'GET',
        url: `${api}/api/v1/legal`,
      })
        .then(({ data }) => {
          this.itemTable = data.data
        })
        .catch(error => {})
    },
    editLegal(item) {
      this.$ga.event({
        eventCategory: 'Legal Config',
        eventAction: 'click',
        eventLabel: `EDIT ITEM ${item.id}`,
      })
      this.$router.push({ path: `/legaledit/${item.id}` })
    },
    addLegal() {
      this.$ga.event({
        eventCategory: 'Legal Config',
        eventAction: 'click',
        eventLabel: `ADD NEW ROW`,
      })
      const self = this
      self.$router.push('addlegal')
    },
  },
}
</script>
<style lang="scss">
@import '~/assets/scss/components/legalconfig.scss';
</style>
